(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.rdsTextarea = factory());
})(this, function () {
  'use strict';

  function textarea(element) {
    var controlEl = element.querySelector("[data-rds-textarea-control]");
    var counterEl = element.querySelector("[data-rds-textarea-counter]");
    var autoGrowDataAttr = element.getAttribute("data-rds-textarea-autogrow");
    function initCounter() {
      if (controlEl) {
        var maxLength = Number(controlEl.getAttribute("maxLength"));
        if (maxLength && maxLength > 0) {
          var value = controlEl.value;
          updateCounter("".concat(maxLength - value.length));
        }
      }
    }
    function updateCounter(value) {
      if (counterEl) {
        counterEl.textContent = value;
      }
    }
    function initAutoGrow() {
      if (controlEl && autoGrowDataAttr !== null) {
        controlEl.style.resize = "none";
        updateHeight("".concat(calcHeight(controlEl), "px"));
      }
    }
    function updateHeight(value) {
      if (controlEl) {
        controlEl.style.height = value;
      }
    }
    function calcHeight(textareaEl) {
      var borderWidth = Number(getComputedStyle(textareaEl).getPropertyValue("border-width").split("px")[0]);
      var roundedBorderWidth = Math.round(borderWidth);
      return textareaEl.scrollHeight + roundedBorderWidth * 2;
    }
    function handleInput() {
      var maxLength = Number(this.getAttribute("maxLength"));
      if (counterEl && maxLength && maxLength > 0) {
        var currentCharacterCount = this.value.length;
        updateCounter("".concat(maxLength - currentCharacterCount));
      }
      if (autoGrowDataAttr !== null) {
        updateHeight("auto");
        updateHeight("".concat(calcHeight(this), "px"));
      }
    }
    function reset() {
      if (controlEl) {
        controlEl.value = "";
        if (autoGrowDataAttr !== null) {
          updateHeight("auto");
          updateHeight("".concat(calcHeight(controlEl), "px"));
        }
        if (counterEl) {
          var maxLength = Number(controlEl.getAttribute("maxLength"));
          updateCounter("".concat(maxLength));
        }
      }
    }
    function setup() {
      initCounter();
      initAutoGrow();
      if (controlEl) {
        controlEl.addEventListener("input", handleInput);
      }
    }
    setup();
    return {
      reset: reset
    };
  }
  return textarea;
});